import _ from 'underscore';
import Backbone from 'backbone';
import ko from 'knockout';
import ViewModel from '@bingads-webui-component-legacy/cx-select/viewmodel/cxSelect';
import defaultTemplate from '@bingads-webui-component-legacy/cx-select/template/cxSelect.pug';

export default class View extends Backbone.View {
  initialize({
    template = defaultTemplate,
    value,
    selectsCss,
    selectsLabel,
    selectOptions,
    caption,
    i18n,
    id,
    label,
    labelledby,
    describedby,
  } = {}) {
    this.template = template;
    this.viewModel = new ViewModel({
      value,
      selectsCss,
      selectsLabel,
      selectOptions,
      caption,
      i18n,
    });

    this.viewModel.path.subscribe((path) => {
      this.trigger('update', _.last(path), path);
    });

    this.on('update:path', (path) => {
      this.viewModel.updatePath(path);
    });

    this.attrs = _.pick({
      id,
      'aria-label': labelledby ? null : label,
      'aria-labelledby': labelledby,
      'aria-describedby': describedby,
    }, Boolean);
  }

  render() {
    // give id to this.$('.cx-select')
    this.$el.removeAttr('id');

    this.$el.html(this.template({
      attrs: this.attrs,
    }));
    ko.applyBindings(this.viewModel, this.el);
    return this;
  }

  getPath() {
    return this.viewModel.path();
  }

  static findValuePath(value, pairs) {
    return ViewModel.findValuePaths(value, pairs)[0] || [];
  }
}
